import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { RequestsService } from '../requests.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { Observable, finalize } from 'rxjs';
import { AddCererePayload } from '../request.interface';
import { Generic, GenericCompartiment, GenericDirectie } from 'src/app/interfaces/generic.interface';
import { DirectiiService } from '../../../settings-sidenav/directii/directii.service';
import { CompartimenteService } from '../../../settings-sidenav/compartimente/compartimente.service';
import { CerereTypeService } from '../../../settings-sidenav/cerere-type/cerere-type.service';
import { DepartmentsService } from '../../../settings-sidenav/departments-settings/departments.service';
import { CerereStatusService } from '../../../settings-sidenav/cerere-status/cerere-status.service';
import { CererePriorityService } from '../../../settings-sidenav/cerere-priority/cerere-priority.service';

@Component({
	selector: 'app-add-request',
	templateUrl: './add-request.component.html',
	styleUrls: ['./add-request.component.scss'],
})
export class AddRequestComponent implements OnInit {
	// general error
	errorTitle: string = helper.dialogConfig.headers.errorAtentie;
	errorIcon: string = helper.dialogConfig.icons.error;
	errorType: string = helper.dialogConfig.icons.error;
	helper = helper;

	directii$!: Observable<Generic[]>;
	compartimente$!: Observable<Generic[]>;
	requestTypes$!: Observable<Generic[]>;
	departamente$!: Observable<Generic[]>;
	requestStatuses$!: Observable<Generic[]>;
	requestPriorities$!: Observable<Generic[]>;

	token!: string;
	isLoading = false;
	form: FormGroup = new FormGroup({
		id_user_assigned: new FormControl('', [Validators.required]),
		id_user_submitter: new FormControl('', [Validators.required]),
		id_departament: new FormControl('', [Validators.required]),
		id_directie: new FormControl('', [Validators.required]),
		id_compartiment: new FormControl('', [Validators.required]),
		id_modified_user: new FormControl('', [Validators.required]),
		id_cetatean: new FormControl('', [Validators.required]),
		id_cerere_type: new FormControl('', [Validators.required]),
		id_cerere_status: new FormControl('', [Validators.required]),
		id_cerere_priority: new FormControl('', [Validators.required]),
		id_cerere_departament: new FormControl('', [Validators.required]),
		subject: new FormControl('', [Validators.required]),
		description: new FormControl('', [Validators.required]),
		email_date: new FormControl(new Date().toISOString(), [
			Validators.required,
		]),
		email_status: new FormControl('', [Validators.required]),
		ip: new FormControl('', [Validators.required]),
		source: new FormControl('', [Validators.required]),
		id_cetatean_m: new FormControl('', [Validators.required]),
		validated_date: new FormControl(new Date().toISOString(), [
			Validators.required,
		]),
		validated_user_id: new FormControl('', [Validators.required]),
		validated_user_name: new FormControl('', [Validators.required]),
		validated_obs: new FormControl('', [Validators.required]),
		cancel_date: new FormControl(new Date().toISOString(), [
			Validators.required,
		]),
		cancel_user_id: new FormControl('', [Validators.required]),
		cancel_user_name: new FormControl('', [Validators.required]),
		cancel_obs: new FormControl('', [Validators.required]),
		cancel_type: new FormControl('', [Validators.required]),
		resolved_date: new FormControl(new Date().toISOString(), [
			Validators.required,
		]),
		modified_user_name: new FormControl('', [Validators.required]),
	});

	constructor(
		private dialogRef: MatDialogRef<AddRequestComponent>,
		private requestsService: RequestsService,
		private notificationService: NotificationService,
		private authService: AuthService,
		private directiiService: DirectiiService,
		private compartimenteService: CompartimenteService,
		private cerereTypeService: CerereTypeService,
		private departmentsService: DepartmentsService,
		private cerereStatusService: CerereStatusService,
		private cererePriorityService: CererePriorityService
	) {
		this.processToken();
	}

	ngOnInit(): void {
		this.loadDirectii();
		this.loadCompartimente();
		this.loadRequestTypes();
		this.loadDepartamente();
		this.loadRequestStatuses();
		this.loadRequestPriorities();
	}

	loadRequestPriorities() {
		this.isLoading = true;
		this.requestPriorities$ = this.cererePriorityService
			.getCererePriorities()
			.pipe(
				finalize(() => {
					this.isLoading = false;
				})
			);
	}

	loadRequestStatuses() {
		this.isLoading = true;
		this.requestStatuses$ = this.cerereStatusService.getStatuses().pipe(
			finalize(() => {
				this.isLoading = false;
			})
		);
	}

	loadDepartamente() {
		this.isLoading = true;
		this.departamente$ = this.departmentsService.getDepartamente().pipe(
			finalize(() => {
				this.isLoading = false;
			})
		);
	}

	loadRequestTypes() {
		this.isLoading = true;
		this.requestTypes$ = this.cerereTypeService.getRequestTypes().pipe(
			finalize(() => {
				this.isLoading = false;
			})
		);
	}

	loadDirectii() {
		this.isLoading = true;
		this.directii$ = this.directiiService.getDirectii().pipe(
			finalize(() => {
				this.isLoading = false;
			})
		);
	}

	loadCompartimente() {
		this.isLoading = true;
		this.compartimente$ = this.compartimenteService.getCompartimente().pipe(
			finalize(() => {
				this.isLoading = false;
			})
		);
	}

	closeDialog() {
		this.dialogRef?.close({
			success: false,
		});
	}

	processToken() {
		const tokenObj = this.authService.returnTokenUser();
		tokenObj.then((token) => {
			this.token = token;
			this.requestsService.setToken(token);
		});
	}

	submitForm() {
		this.isLoading = true;

		const newRequest: AddCererePayload = this.form.value;

		this.requestsService
			.addRequest(newRequest)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe({
				next: (res) => {
					this.dialogRef.close({ success: true });
				},
				error: (err) => {
					let msg;
					try {
						// try to catch the message from server
						msg = err.error.errors.message[0];
					} catch (error) {
						// controll output message
						msg = helper.dialogConfig.generalMessages.error;
					}
					this.notificationService.warningSwal(
						this.errorTitle,
						msg,
						this.errorIcon
					);
				},
			});
	}
}
